<template>
    <div class="input-container position-fan">
        <div class="element">
            <div class="option-container">
                <div class="custom-select" :class="{expanded : isExpanded}">

                    <div class="selected_item">
                        <transition name="fade" mode="out-in">
                            <span :key="getActive.name" v-if="getActive" class="value" v-html="getActive.name"/>
                            <span v-else="isVisited" class="value" :class="{error_placeholder: isVisited}"
                                  v-html="placeholder"/>
                        </transition>
                        <transition name="fade" mode="out-in">
                            <span :key="getActive.name" v-if="getActive" class="value"/>
                            <span v-else="isVisited" class="value"
                                  :class="{incorrect: isVisited, hidden_msg: !isVisited}"
                                  v-html="translate(errorMsg)"/>
                        </transition>
                        <span class="icon-bottom_arrow"/>
                    </div>
                    <div class="items-container" v-if="isEditable">
                        <div class="item" v-for="(element, id) in initialData"
                             :id="id" @click="() => {if(isEditable) selectElementOfPositionFan(id)}"
                             v-html="element.name">
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "inputPositionFan",
        props: ['title', 'placeholder', 'initialData', 'require', 'name'],
        data() {
            return {
                value: '',
                selectedId: '',
                isEdited: false,
                isVisited: false,
                errorMsg: 'error_msg_select_option',
                isExpanded: false,
            }
        },

        methods: {

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            toggleExpandOfCustomSelect(e) {
                if (!this.isEditable) {
                    return;
                }

                let target = e.target;

                document.querySelectorAll('.selected_item').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        this.isExpanded = !this.isExpanded;
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        this.isExpanded = !this.isExpanded;
                        return;

                    } else if (target.classList.contains('items-container')) {

                        this.isExpanded = false;
                        this.isVisited = true;

                        return;

                    } else if (target.classList.contains('item')) {

                        this.isExpanded = false;
                        this.isVisited = true;

                        return;

                    } else {

                        this.isExpanded ? this.isVisited = true : '';
                        this.isExpanded = false;

                        return;
                    }
                }
            },

            selectElementOfPositionFan(id) {
                this.$store.commit({
                    type: 'selectElementOfPositionFan',
                    id: id,
                });
                this.selectedId = id;
            },

            emitValidateData() {

                this.isVisited = true;
                this.isExpanded = false;

                this.$parent.$emit('validateData', {
                    title: this.name,
                    isIncorect: this.getActive ? this.isVisited = false : this.isVisited,
                    value: this.getActive.value,
                    selectedId: this.selectedId
                });
            }
        },

        computed: {

            getActive() {

                let _this = this;

                let activeElement = '';

                Object.keys(_this.initialData).forEach(function (element) {

                    if (_this.initialData[element].active) {

                        activeElement = _this.initialData[element];
                    }
                });

                return activeElement;
            },

            isEditable() {
                return this.$store.getters.isOfferEditable;
            }
        },

        mounted() {
            document.addEventListener("click", this.toggleExpandOfCustomSelect);

            this.$parent.$on('getValidateData', () => {

                this.emitValidateData();
            });

            if (this.$store.state.productCard.custom.summary_form[this.name] !== undefined) {
                setTimeout(() => {
                    this.selectElementOfPositionFan(this.$store.state.productCard.custom.summary_form[this.name].selectedId);
                    this.isVisited = true;
                }, 10); //TODO: ogarnąć czemu znowu store się nie reloaduje;
            } else {
                setTimeout(() => {
                    if (this.initialData) {
                        this.selectElementOfPositionFan(0)
                    }
                }, 10);
            }
        },

        beforeDestroy() {
            document.removeEventListener("click", this.toggleExpandOfCustomSelect);
        }
    }
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }
</style>